// alterado - revisado

import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem4sm12xs12,
    GridItem7sm12xs12,
    GridItem8sm12xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import mapaFinanceiroGrupoList from '../../../business-rules/List/mapaFinanceiroGrupoList'

import mapaFinanceiroItemList from '../../../business-rules/List/mapaFinanceiroItemList'

import MapaFinanceiroChart from './MapaFinanceiroChart'



const MapaFinanceiroFormGrafico = ({ values, report }) => {
    
    const GridItem4sm12xs12MapaFinanceiroFormGrafico = report ? GridItem12 : GridItem4sm12xs12
    const GridItem8sm12xs12MapaFinanceiroFormGraficot = report ? GridItem12 : values.modoApresentacao ? GridItem7sm12xs12 : GridItem8sm12xs12

    const GraficoMapaFinanceiro = () => {

        return (
            <CardGridDivBody>
                <GridContainer>
                    <GridItem4sm12xs12MapaFinanceiroFormGrafico>
                        <table
                            border='0'
                            cellPadding='0'
                            cellSpacing='0'
                            width='100%'
                            style={{
                                paddingTop: '10px',
                                paddingRight: '20px',
                                paddingLeft: '20px',
                                //paddingBottom: '10px',
                            }}
                        >
                            <tbody>
                                
                                    <tr>
                                        <td/>
                                        <td
                                            className='font-bold'
                                            align="center"
                                            style={{
                                                padding: '5px',
                                            }}
                                        >
                                            {LABEL.atual}
                                        </td>
                                        <td
                                            className='font-bold'
                                            align="center"
                                            style={{
                                                padding: '5px',
                                            }}
                                        >
                                            {LABEL.ideal}
                                        </td>
                                    </tr>
                                    {values.mapaFinanceiro?.map((item, ind) => {

                                        const linhaMapaFinanceiroItem =
                                            pesquisaList(mapaFinanceiroItemList, 
                                                item.id)

                                        const linhaMapaFinanceiroGrupo =
                                            pesquisaList(mapaFinanceiroGrupoList, 
                                                linhaMapaFinanceiroItem.grupo)

                                        return (
                                            <tr
                                                key={ind}
                                                className='text-white font-light text-11'
                                                bgcolor={linhaMapaFinanceiroGrupo.bgColor}
                                            >
                                                <td
                                                    className='text-15 font-medium'
                                                    width='18%'
                                                    style={{
                                                        border: '1px solid',
                                                        padding: '5px',
                                                    }}
                                                >
                                                    {linhaMapaFinanceiroItem.descricao}
                                                </td>
                                                <td
                                                    className='text-14 text-center'
                                                    width='7%'
                                                    style={{
                                                        border: '1px solid',
                                                        padding: '5px',
                                                    }}
                                                >
                                                    {item.nota}
                                                </td>
                                                <td
                                                    className='text-14 text-center'
                                                    width='7%'
                                                    style={{
                                                        border: '1px solid',
                                                        padding: '5px',
                                                    }}
                                                >
                                                    {HARDCODE.notaIdeal}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                
                                <tr>
                                    <td>
                                        <br/>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </GridItem4sm12xs12MapaFinanceiroFormGrafico>

                    <GridItem8sm12xs12MapaFinanceiroFormGraficot>
                        <MapaFinanceiroChart
                            values={values}
                            report={report}
                        />
                    </GridItem8sm12xs12MapaFinanceiroFormGraficot>
                </GridContainer>
            </CardGridDivBody>
        )
    }

    return (
        <GridContainer>
            <GridItem12>
                <GraficoMapaFinanceiro/>
            </GridItem12>
        </GridContainer>
    )
}

export default MapaFinanceiroFormGrafico